import { render, staticRenderFns } from "./BizTaskSelectEntrusterModal.vue?vue&type=template&id=e96e3148&scoped=true&"
import script from "./BizTaskSelectEntrusterModal.vue?vue&type=script&lang=js&"
export * from "./BizTaskSelectEntrusterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96e3148",
  null
  
)

export default component.exports